// extracted by mini-css-extract-plugin
module.exports =  {"divider":"AQqUn3RhoBfXvAybxkFn","center":"wCtkPUHdO06b7tyEkohR"};